<template>
    <div class="dashboard-comments inner-pages volunteering-timesheet shape-available">
        <div class="shape-wrapper">
				  <div class="shape-content"></div>
			  </div>
        <header>
            <ThePrimaryHeader></ThePrimaryHeader>
        </header>
        <main>
            <DashboardBreadcrumb />
            <div class="dashboard-tab-content">
                <b-container>
                    <div class="heading-section">
                        <h1>{{ getTrans('label.comments')}}</h1>
                    </div>
                    <div class="inner-content-wrap">
                        <b-list-group class="status-bar inner-statusbar">
                            <b-list-group-item>
                              <div id="published" class="list-item">
                                <i class="p-2">
                                  <img :src="$store.state.imagePath+'/assets/images/document_accepted.svg'" alt width="20" height="20"/>
                                </i>
                                <p>
                                  <span class="font-weight-bolder text-dark">{{statsField.published}}</span>{{getTrans('label.published')}}
                                </p>
                              </div>
                            </b-list-group-item>
                            <b-list-group-item>
                              <div id="pending" class="list-item">
                                <i class="p-2">
                                  <img :src="$store.state.imagePath+'/assets/images/document_pending.svg'" alt width="20" height="20"/>
                                </i>
                                <p>
                                  <span class="font-weight-bolder text-dark">{{statsField.pending}}</span>{{getTrans('label.pending')}}
                                </p>
                              </div>
                            </b-list-group-item>
                            <b-list-group-item>
                              <div id="declined" class="list-item">
                                <i class="p-2">
                                  <img :src="$store.state.imagePath+'/assets/images/document_declined.svg'" alt width="20" height="20"/>
                                </i>
                                <p>
                                  <span class="font-weight-bolder text-dark">{{statsField.declined}}</span>{{getTrans('label.declined')}}
                                </p>
                              </div>
                            </b-list-group-item>
                        </b-list-group>
                        <div class="dashboard-table" v-if="commentItems.length">
                            <div class="table-outer">
                                <div class="table-inner">
                                <div class="table-header">
                                  <h3>{{getTrans('label.comment_history')}}</h3>
                                </div>
                                    <app-table
                                      responsive
                                      :items="commentItems"
                                      id="comment-list"
                                      :fields="columns"
                                      :sort-by.sync="sorting.orderBy"
                                      :sort-desc.sync="sorting.orderDesc"
                                      class="table-commnet-list"
                                    >
                                    <template #cell(mission)="{ item }">
                                     <a
                                        target="_blank"
                                        class="table-link"
                                        :href="missionDetailPage(item)"
                                      >
                                        {{ item.mission }}
                                     </a>
                                    </template>
                                    <template #cell(date)="{item}">
                                      {{item.date | userFormatDate}}
                                    </template>
                                    <template #cell(status)="{item}">
                                      <span
                                        :class="[
                                          'status-label',
                                          getStatus(item.status,'class')
                                        ]
                                      ">
                                          <i class="status-icon">
                                            <vueIcon :symbol="getStatus(item.status,'index')" Iwidth="12" Icolor="#fff"></vueIcon>
                                          </i>
                                          {{getStatus(item.status, 'label')}}
                                      </span>
                                    </template>
                                    <template #cell(actions)="{item}">
                                       <a
                                          variant="link"
                                          @click="deleteComments(item.comment_id)"
                                        >
                                        {{ getTrans('label.delete') }}
                                      </a>
                                    </template>
                                    </app-table>
                                </div>
                                <div class="btn-row">
                                    <b-button class="btn-bordersecondary ml-auto" @click="exportFile()">
                                        <span>{{getTrans('label.export')}}</span></b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-container>
            </div>
        </main>
        <footer>
            <TheSecondaryFooter></TheSecondaryFooter>
        </footer>
    </div>
</template>

<script>
  import AppTable from '@components/AppTable';
  import ThePrimaryHeader from "../components/Layouts/ThePrimaryHeader";
  import TheSecondaryFooter from "../components/Layouts/TheSecondaryFooter";
  import DashboardBreadcrumb from "../components/DashboardBreadcrumb";
  import store from '../store';
  import constants from '../constant';
  import ExportFile from "../services/ExportFile";
  import vueIcon from '@components/svg-icon';
  import {
    commentListing,
    deleteComment
  } from "../services/service";
  import {
    setTimeout
  } from 'timers';
  export default {
    components: {
      ThePrimaryHeader,
      TheSecondaryFooter,
      DashboardBreadcrumb,
      AppTable,
      vueIcon
    },

    name: "dashboardcomments",

    data() {
      return {
        selectedMonth: false,
        commentItems: [],
        statsField: {
          'published': 0,
          'pending': 0,
          'declined': 0
        },
        languageData: [],
        message: null,
        isCommentDisplay:true,
        sorting: {
          sortBy: '',
          sortDesc: true
        },
        columns: [
        {
          key: 'mission',
          sortable: true,
          label: this.getTrans('label.mission'),
          class: 'mission-column',
        },
        {
          key: 'date',
          sortable: true,
          label: this.getTrans('label.published_date'),
          class: 'date-column',
        },
        {
          key: 'comment',
          sortable: true,
          label: this.getTrans('label.comment'),
          class: 'comment-column',
        },
        {
          key: 'total_comment_likes',
          sortable: false,
          label: this.getTrans('label.likes'),
          class: 'likes-column',
        },
        {
          key: 'status',
          sortable: false,
          label: this.getTrans('label.status'),
          class: 'status-column'
        },
        {
          key: 'actions',
          label: '',
          class: 'actions-column'
        }
      ],
      statuses: {
        pending: {
          keys: [
            'PENDING',
          ],
          class: 'pending-label',
          label: this.getTrans('label.pending'),
          disabled: false
        },
        published: {
          keys: [
            'PUBLISHED'
          ],
          class: 'approved-label',
          label: this.getTrans('label.published'),
          disabled: false
        },
        declined: {
          keys: [
            'DECLINED',
          ],
          class: 'declined-label',
          label: this.getTrans('label.declined'),
          disabled: false
        },
      },
      };
    },
    methods: {
      getCommentListing() {
        document.body.classList.add("loader-enable");
        commentListing().then(response => {
          if (!response.error) {
            if (response.data && response.data.comments) {
              let data = response.data.comments
              let currentData = [];
              if (data.length > 0) {
                data.filter((item) => {
                  currentData.push({
                    ['mission']: item.title,
                    ['date']: item.created_at,
                    ['comment']: item.comment,
                    ['total_comment_likes']: item.total_comment_likes,
                    ['status']: item.approval_status,
                    ['comment_id']: item.comment_id,
                    ['mission_id']: item.mission_id,
                    ['is_donation_mission']: item.is_donation_mission
                  })

                })
                this.commentItems = currentData
              }
              if (response.data.stats) {
                this.statsField.published = response.data.stats.PUBLISHED;
                this.statsField.pending = response.data.stats.PENDING;
                this.statsField.declined = response.data.stats.DECLINED;
              }
            } else {
              this.commentItems = []
              this.statsField.published = 0;
              this.statsField.pending = 0;
              this.statsField.declined = 0;
            }
          } else {
            this.message = response.message
            this.makeToast('danger', response.message)
          }
          document.body.classList.remove("loader-enable");
        })
      },
      deleteComments(commentId) {

        this.$bvModal.msgBoxConfirm(this.languageData.label.delete_comment, {
          okTitle: this.languageData.label.yes,
          cancelTitle: this.languageData.label.no,
          centered: true,
          modalClass: 'cancel_modal',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0 footer_modal',
        })
          .then(value => {
            if (value == true) {
              document.body.classList.add("loader-enable");
              deleteComment(commentId).then(response => {
                if (response.error == false) {
                  this.getCommentListing();
                  let message = this.languageData.label.comment + ' ' + this.languageData
                    .label
                    .deleted_successfully

                  this.makeToast('success', message)
                } else {
                  this.makeToast('danger', response.message)
                }
                document.body.classList.remove("loader-enable");
              });
            }
          })
      },
      exportFile() {
        document.body.classList.add("loader-enable");
        let fileName = this.languageData.export_timesheet_file_names.COMMENT_LISTING;
        let exportUrl = "app/dashboard/comments/export";
        const payload = {
          'date_format': store.state.userDateFormat
        }

        ExportFile(
          exportUrl, 
          fileName,
          null,
          payload
        );
        document.body.classList.remove("loader-enable");
      },
      makeToast(variant = null, message) {
        this.$bvToast.toast(message, {
          variant: variant,
          solid: true,
          autoHideDelay: 3000
        })
      },
      missionDetailPage(item) {
        const missionDetailPath = item.is_donation_mission
          ? 'donation-mission-detail'
          : 'mission-detail';

        return `${missionDetailPath}/${item.mission_id}`;
      },
      getStatus(stat, property = null) {
        const status = Object
          .values(this.statuses)
          .find(item => item.keys.includes(stat));

        if (property === 'index') {
          return Object
            .keys(this.statuses)
            .find(stat => this.statuses[stat] === status);
        }

        return property
          ? status[property] || null
          : status;
      },
    },
    created() {
      this.languageData = JSON.parse(store.state.languageLabel);
      this.isCommentDisplay = this.settingEnabled(constants.MISSION_COMMENTS) || this.settingEnabled(constants.SETTING_DONATION_MISSION_COMMENTS)
      if(!this.isCommentDisplay) {
        this.$router.push('/home')
      }
      setTimeout(() => {
        this.getCommentListing()
      }, 50);

    }
  };

</script>
